module.exports = __webpack_public_path__ + "static/media/fam2.062a4206.png";